export default {
    assignLocation: 'Assign Location',
    selected: 'Selected',
    locationName: 'Location name',
    confirm: 'Confirm',
    update: 'Update',
    locationSuccessfully: 'location successfully',
    errorMessage: 'Error Message'
}
